<template>
  <div>
    <div v-if="validateSession">

      <div id="App">  
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
        <div class="vertical-nav bg-white" id="sidebar">
          <div class="py-4 px-3 mb-4 bg-light">
            <div class="media d-flex align-items-center"><img :src="imagen" alt="..." width="65" class="mr-3 rounded-circle img-thumbnail shadow-sm">
              <div class="media-body">
                <h5 class="m-0 text-truncate" style="max-width: 150px;">{{users.name}}</h5>
                <p class="font-weight-light text-truncate" style="max-width: 150px;" :title="users.email">{{users.email}}</p>
                <h6>{{users.id_rol}}</h6>
              </div>
            </div>
          </div>
        
          <p class="text-gray font-weight-bold text-uppercase px-3 small pb-4 mb-0">Mis Modulos</p>
        
          <ul class="nav flex-column bg-white mb-0" @click="navegacion(item.href)" v-for="(item,index) in items" v-bind:key="index">
            <li class="nav-item" >
              <a class="nav-link text-dark" style="cursor: pointer;">
                <i :class="item.faIcon + ' mr-3 text-primary'"></i>{{item.name}}
              </a>
            </li>           
          </ul>
          
          <p class="text-gray font-weight-bold text-uppercase px-3 small py-4 mb-0">Opciones</p>
         
          <ul class="nav flex-column bg-white mb-0">
            <li class="nav-item" @click="navegacion('datos-personales')">
              <a class="nav-link text-dark" style="cursor: pointer;">
                <i class="mdi mdi-account-box mr-3 text-primary"></i> Datos Personales
              </a>
            </li>  
            <li class="nav-item" @click="cerrarSesion()">
              <a class="nav-link text-dark" style="cursor: pointer;">
                <i class="mdi mdi-logout mr-3 text-primary"></i> Cerrar Sesión
              </a>
            </li>          
          </ul>
          

          <div class="d-flex bg-white text-dark align-items-center px-3 py-2" style="position: absolute; bottom: 0px;">  
            
            <!-- <img src="../assets/logo.png" class="mr-auto" width="20%"> -->
            <b-button variant="secundary" size="sm"><i class="mdi mdi-bug"></i> Reportar Error</b-button>
            <b-button size="sm">v1.0</b-button>

          </div>

        </div>
        <div class="page-content p-5" id="content">
          <!-- Toggle button -->
          <button id="sidebarCollapse" @click="cerrarMenu" type="button" class="btn btn-light bg-white rounded-pill shadow-sm px-4 mb-4"><i class="fa fa-bars mr-2"></i><small class="text-uppercase font-weight-bold"> Menú</small></button> &nbsp;
          <!-- <button @click="navegacion('dashboard')" type="button" class="btn btn-light bg-white rounded-pill shadow-sm px-4 mb-4"><i class="fa fa-home mr-2"></i><small class="text-uppercase font-weight-bold"> Dashboard</small></button> -->
        
          <router-view style="width: 100%; display: block; margin:auto;"></router-view>
        
        </div>
                  
          
        
        

      </div>
      
    </div>

    <main v-if="!validateSession" style="background-color: white !important;">      

      <router-view></router-view>

    </main>
    
  </div>
</template>
<script>
import {headers} from './../api/headers'
import {configApi} from './../api/configApi'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.slim.min.js';
import 'popper.js/dist/umd/popper.min.js';
import 'jquery/dist/jquery.min.js';
import $ from 'jquery'; 
  export default {
    components: {
      
    },
    data: () => ({ 
      drawer: null,
      items_predeterminados: [
        {
          title: 'Cerrar Sesión',
          icon: 'mdi-arrow-right-box',
          name: '/logout'
        },        
      ],
      imagen: require('../assets/logo.png'),
      mainProps: { width: 50, height: 50 },
      right: null,
      validateSession: false,
      initialShow: true,
      header: "<h3>Administrador</h3>",
      items: [],
      users: {
          name: '',
          id_rol: '',
          email: ''
      },
    }),
    mounted() {
      this.validarAccesoMenu()
      this.listarMenus()   
      this.getDatosPersonales()   
    },
    methods: {
      cerrarMenu() {        
        $('#sidebar, #content').toggleClass('active');
      },
      onSidebarChanged() {},
      navegacion(menu) {
        this.$router.push('/'+menu)
      },
      async validarAccesoMenu() {

        if(localStorage.getItem('access_token')) {

          return await this.axios.get(configApi+'usuarios/acceso_menu', {headers})
          .then(response => {
            if(response.data.status == 401) {
              this.validateSession = false
            } else {
              this.validateSession = true
            }
          }).catch(error => {
            localStorage.removeItem('access_token')
          })

        } 

      },
      async listarMenus() {

        if(localStorage.getItem('access_token')) {

          return await this.axios.get(configApi+'usuarios/listado_menu_permisos', {headers})
          .then(response => {
            this.items = response.data.data
            console.log(this.items)
          })

        }

      },
      async getDatosPersonales() {

      return await this.axios.get(configApi+'usuarios/datos_personales', {headers})
      .then(response => {   
          
          this.users.name = response.data.data[0].name   
          this.users.id_rol = response.data.data[0].id_rol == 1 ? 'Administrador' : 'Cliente'              
          this.users.email = response.data.data[0].email

      })

      },
      cerrarSesion() {
        localStorage.removeItem('access_token')
        window.location.href = "https://admin.generaideasia.com/login"
      }
    }
  }
</script>
<style>

.vertical-nav {
  min-width: 17rem;
  width: 17rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.4s;
}
.page-content {
  width: calc(100% - 17rem);
  margin-left: 17rem;
  transition: all 0.4s;
}
/* for toggle behavior */
#sidebar.active {
  margin-left: -17rem;
}
#content.active {
  width: 100%;
  margin: 0;
}
@media (max-width: 768px) {
  #sidebar {
    margin-left: -17rem;
  }
  #sidebar.active {
    margin-left: 0;
  }
  #content {
    width: 100%;
    margin: 0;
  }
  #content.active {
    margin-left: 17rem;
    width: calc(100% - 17rem);
  }
}
/*
*
* ==========================================
* FOR DEMO PURPOSE
* ==========================================
*
*/
body {
  /* background: #E8EAF6!important; */
  min-height: 100vh;
  overflow-x: hidden;
}
.separator {
  margin: 3rem 0;
  border-bottom: 1px dashed #fff;
}
.text-uppercase {
  letter-spacing: 0.1em;
}
.text-gray {
  color: #aaa;
}
</style>